export default __webpack_public_path__ + "static/media/info-blue.38bb7e26.svg";